<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      3.1 {{ $t('common_words.contact_position_info') }}
    </p>
    <hr />
    <div class="row sticky-button px-1 mb-2">
      <div class="col-12 col-md-6 col-lg-5">
        <div class="form-group has-label">
          <minus-plus
            :label="`${$t('common_words.contact_number')}: *`"
            mr="2rem !important"
            @handlePlus="handlePlusConctact"
            @handleMinus="handleMinusConctact"
            :value="model.contacts_number"
          />
        </div>
      </div>
    </div>
    <div class="row" v-for="index in getNumberContacts" :key="index">
      <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.contact_name')}: *`"
          v-model="model.contact_names[index - 1]"
          name="common_words.contact_name"
          v-validate="modelValidations.contact_name"
          :error="getError('common_words.contact_name', true)"
          placeholder="Juan Perez"
          @change="model.contacts_rel = []"
        ></fg-input>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-3 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.contact_position')}: *`"
          :placeholder="$t('common_words.contact_position_example')"
          name="common_words.contact_position"
          v-validate="modelValidations.contact_positions"
          :error="getError('common_words.contact_position', true)"
          v-model="model.contact_positions[index - 1]"
        >
        </fg-input>
      </div>
      <div class="col-sm-12 col-md-7 col-lg-3 col-xl-2">
        <fg-input
          type="number"
          :label="`${$t('common_words.phone')}: *`"
          v-model.number="model.contact_phones[index - 1]"
          name="common_words.phone"
          v-validate="modelValidations.contact_phone"
          :error="getError('common_words.phone', true)"
          placeholder="3125689741"
        ></fg-input>
      </div>
      <hr />
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import mixinMasters from 'src/util/mixinMasters';
import i18n from 'src/i18n';

export default {
  components: { [MinusPlus.name]: MinusPlus },
  data() {
    return {
      model: {
        contacts_number: 1,
        nContacts: 0,
        contact_names: [],
        contact_phones: [],
        contact_positions: [],
        contacts_rel: [],
      },
      modelValidations: {
        contact_name: {
          required: true,
        },
        contact_phone: {
          required: true,
          numeric: true,
        },
        contact_positions: {
          required: true,
        },
        contacts_number: {
          required: true,
          max: 3,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  methods: {
    handlePlusConctact() {
      this.model.contacts_number++;
      this.updateContact();
    },
    handleMinusConctact() {
      if (this.model.contacts_number > 1) {
        this.model.contacts_number--;
        this.updateContact();
      }
    },
    validate() {
      this.model.contact_names = this.model.contact_names;
      this.model.contact_phones = this.model.contact_phones;
      this.model.contact_positions = this.model.contact_positions;

      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', {
          ...this.model,
          contact_names: this.model.contact_names,
          contact_phones: this.model.contact_phones,
          contact_positions: this.model.contact_positions,
        });

        return res;
      });
    },
    async updateContact() {
      if (
        this.model.contacts_number &&
        this.model.contacts_number.toString().length <= 3
      ) {
        this.model.contact_names = this.model.contact_names;
        this.model.contact_names = this.model.contact_names.splice(
          0,
          this.model.contacts_number
        );
        this.model.contact_phones = this.model.contact_phones.splice(
          0,
          this.model.contacts_number
        );
        this.model.contact_positions = this.model.contact_positions.splice(
          0,
          this.model.contacts_number
        );
      }
    },
  },
  computed: {
    getNumberContacts() {
      if (
        this.model.contacts_number &&
        this.model.contacts_number.toString().length <= 3
      )
        return this.model.contacts_number;
      else return 0;
    },
  },
  created() {
    this.showHideLoading();
  },

  mounted() {
    if (this.isUpdate() || this.isCreate()) {
      const editForm = sessionStorage.getItem('editForm');
      if (editForm) {
        const { business_contacts } = JSON.parse(editForm);

        this.model.contacts_number =
          business_contacts.length > 0 ? business_contacts.length : 0;

        business_contacts.forEach(({ name, position, phone, contacts }) => {
          this.model.contact_names.push(name);
          this.model.contact_positions.push(position);
          this.model.contact_phones.push(phone);
        });
      }
    }
  },
};
</script>
<style></style>
